import unmute from '../functions/unmute';
import { isProductionEnvironment } from '../helpers/is-production.helper';
export var useUnmute = function (audioContext) {
    var done = false;
    document.body.addEventListener('click', function () {
        if (done)
            return;
        done = true;
        var oscillator = audioContext.createOscillator();
        oscillator.type = 'sine';
        oscillator.frequency.value = 1000;
        var gainNode = audioContext.createGain();
        gainNode.gain.value = 0;
        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);
        oscillator.start(0);
        setTimeout(function () { return oscillator.stop(); }, 100);
        if (!isProductionEnvironment()) {
            console.log('========== web audio unmute, registered');
        }
    });
    unmute(audioContext);
};
